<template>
  <modal
    :name="name"
    class="add-event-modal"
    v-bind:class="{ 'show-more-options': show_more_options }"
    height="auto"
    :reset="true"
    :draggable="false"
  >
    <form v-on:submit.prevent="storeEvent()">
      <div class="modal-header">
        <div class="modal-header-btns">
          <button
            type="button"
            class="btn btn-link btn-with-icon"
            @click="hide"
          >
            <i class="icon-close"></i>
          </button>
        </div>
      </div>
      <div class="modal-body">
        <div class="form-group">
          <input
            class="form-control"
            id="titleInput"
            v-model="event.title"
            v-bind:placeholder="texts.add_event_title"
          />
        </div>
        <div class="form-group row">
          <div class="col-sm-6" v-if="action === 'edit'">
            <label class="form-check-label" for="start_date">{{
              texts.start_date
            }}</label>

            <date-input
              name="start_date"
              v-model="start_date"
              :required="true"
              :clear-button="false"
              @input="startDateChanged"
            ></date-input>

            <!-- <v-date-picker
              :input-props="{
                id: 'start_date',
                class: 'form-control',
                placeholder: datePlaceholder,
                readonly: action === 'schedule',
              }"
              popover-visibility="focus"
              mode="date"
              :is-required="true"
              :formats="formats"
              @input="startDateChanged()"
              v-model="start_date"
            >
            </v-date-picker> -->
          </div>
          <div class="col-sm-3">
            <label class="form-check-label" for="start_time">{{ texts.start_hour }}</label>
            <input id="start_time" type="time" step="300" :value="start_time"
                   class="form-control" @input="onStartTimeChange($event.target.value)" />
          </div>
          <div class="col-sm-3">
            <label class="form-check-label" for="end_time">{{ texts.end_hour }}</label>
            <input id="end_time" type="time" step="300" :value="end_time"
                   class="form-control" @input="onEndTimeChange($event.target.value)" />
            <small class="form-text text-muted">{{ texts.duration || 'Durată' }}: {{ durationLabelText }}</small>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-6" v-for="field in visibleExtraFields">
            <div
              class="form-group form-check mb-2"
              v-if="field.type == 'checkbox'"
            >
              <input
                type="checkbox"
                class="form-check-input"
                v-bind:id="field.name"
                v-model="event.extra_options[field.name]"
              />
              <label class="form-check-label" v-bind:for="field.name">{{
                field.title
              }}</label>
            </div>
            <div class="form-group" v-else>
              <label v-bind:for="field.name">{{ field.title }}</label>
              <input
                type="text"
                v-bind:id="field.name"
                v-model="event.extra_options[field.name]"
                class="form-control"
              />
            </div>
          </div>
        </div>

        <div class="form-group" v-if="show_more_options">
          <div class="form-check mb-2" v-if="canScheduleRecurringEvents">
            <input
              type="checkbox"
              class="form-check-input"
              id="is_recurring"
              v-model="is_recurring"
            />
            <label class="form-check-label" for="is_recurring">{{
              texts.repeat_event
            }}</label>
          </div>

          <div class="row" v-if="canScheduleRecurringEvents">
            <div class="col-sm-6 mb-1" v-if="is_recurring">
              <label class="form-check-label">{{ texts.days_of_week }}</label>
              <div class="form-row scheduled-days-badge">
                <span
                  class="badge m-1"
                  v-for="day in weekDays"
                  v-bind:class="{
                    'badge-primary': day.selected,
                    'badge-light': !day.selected,
                  }"
                  v-on:click="toggleWeekDay(day)"
                  >{{ day.name }}</span
                >
              </div>
            </div>

            <div class="col-sm-6 mb-1" v-if="is_recurring">
              <p>{{ texts.recurring_end }}</p>

              <div class="form-check mb-2">
                <input
                  type="radio"
                  class="form-check-input"
                  id="recurring_never_ends"
                  value="never"
                  name="recurring-end"
                  v-model="recurring_end"
                />
                <label class="form-check-label" for="recurring_never_ends">{{
                  texts.recurring_never_ends
                }}</label>
              </div>

              <div class="form-check mb-2">
                <input
                  type="radio"
                  class="form-check-input"
                  id="recurring_ends_on_date"
                  value="on-date"
                  name="recurring-end"
                  v-model="recurring_end"
                />
                <label class="form-check-label" for="recurring_ends_on_date">{{
                  texts.recurring_ends_on_date
                }}</label>

                <date-input
                  name="end_date"
                  v-model="end_date"
                  :required="true"
                  :clear-button="false"
                  @input="endDateChanged"
                ></date-input>

                <!-- <v-date-picker
                  :input-props="{
                    class: 'form-control',
                    placeholder: datePlaceholder,
                    readonly: recurring_end !== 'on-date',
                  }"
                  mode="date"
                  popover-visibility="focus"
                  :is-required="true"
                  :formats="formats"
                  @input="endDateChanged()"
                  v-model="end_date"
                >
                </v-date-picker> -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer pull-right">
        <button
          type="button"
          class="btn btn-link"
          v-if="!show_more_options && hasMoreOptions"
          @click="show_more_options = true"
        >
          {{ texts.more_options }}
        </button>
        <button class="btn btn-success" :disabled="saving">{{ texts.save }}</button>
      </div>
    </form>
  </modal>
</template>

<script>
import ModalBase from "./ModalBase.vue";
import { WeekDays } from "../mixins/WeekDaysMixin";
import { EventTimeMixin } from "../mixins/EventTimeMixin";
import { en, ru, ro } from "vuejs-datepicker/dist/locale";

export default {
  extends: ModalBase,
  mixins: [WeekDays, EventTimeMixin],

  props: {
    defaultEventTitle: {
      default: "",
    },
    canScheduleRecurringEvents: {
      default: true,
    },
    timeMask: {
      default: "##:##",
    },
    datePlaceholder: {
      default: "ZZ/LL/AAAA",
    },
    timePlaceholder: {
      default: "--:--",
    },
    eventExtraFields: {
      default: () => [],
    },
    formats: {
      title: "MMMM YYYY",
      weekdays: "W",
      navMonths: "MMM",
      input: ["L", "YYYY-MM-DD", "YYYY/MM/DD"],
      dayPopover: "L",
      data: ["L", "YYYY-MM-DD", "YYYY/MM/DD"], // For attribute dates
    },
  },

  data() {
    return {
      ro,
      ru,
      en,
      event: {
        extra_options: {},
      },
      saving: false,
      start_date: new Date(),
      end_date: new Date(),
      start_time: "",
      end_time: "",
      is_recurring: false,
      show_more_options: false,
      recurring_end: "never",
    };
  },

  mounted() {
    console.log("Timetable Add Event Modal Component Mounted.");

    this.eventBus.$on("create-event", this.createEvent);
  },

  methods: {
    createEvent(eventData) {
      this.event = {
        title: eventData.title || this.defaultEventTitle,
        type: eventData.type,
      };
      this.is_recurring = false;
      this.show_more_options = false;
      this.start_date = this.end_date = moment(eventData.start_date).toDate();
      this.initEventTimes(
        eventData.start_time,
        eventData.end_time || eventData.start_time
      );
      this.recurring_end = "never";

      this.event.extra_options = {};
      this.visibleExtraFields.forEach((field) => {
        this.event.extra_options[field.name] = field.default;
      });

      this.initWeekDays();
      this.show();
    },

    storeEvent() {
      // Nothing disabled the button, so a double click posted the event twice.
      if (this.saving) return;

      this.createEventData();
      this.saving = true;

      // The modal used to hide immediately and re-open on failure, so a failed save
      // looked like a success for as long as the request took. Stay open until the
      // server answers, then close only if it actually succeeded.
      this.eventBus.$emit("store-event", this.event, (err) => {
        this.saving = false;

        if (!err) this.hide();
      });
    },

    startDateChanged() {
      if (this.end_date && moment(this.start_date).isAfter(this.end_date)) {
        console.log("IS AFTER");
        this.end_date = this.start_date;
      }
    },

    endDateChanged() {
      if (this.end_date && moment(this.start_date).isAfter(this.end_date)) {
        this.start_date = this.end_date;
      }
    },

    createEventData() {
      let start_date = moment(this.start_date);
      let end_date = moment(this.end_date);
      let start_time = moment(start_date);
      let end_time = moment(start_date);
      let _start_time = moment(this.start_time, "HH:mm");
      let _end_time = moment(this.end_time, "HH:mm");

      start_time.hour(_start_time.hour());
      start_time.minute(_start_time.minute());

      end_time.hour(_end_time.hour());
      end_time.minute(_end_time.minute());

      // Use start time for start date to fix timezone issues??
      this.event.start_date = this.formatDate(start_time);
      this.event.start_time = this.formatDate(start_time);
      this.event.end_time = this.formatDate(end_time);
      this.event.is_recurring = this.is_recurring;

      if (this.is_recurring) {
        if (this.recurring_end == "on-date") {
          this.event.end_date = this.formatDate(end_date.clone().endOf("day"));
        }

        this.event.recurring_pattern = {
          recurring_type_id: "weekly",
          days_of_week: this.selectedWeekDays,
        };
      } else {
        this.event.recurring_pattern = null;
      }
    },

    formatDate(date) {
      return date.format();
    },
  },
  computed: {
    // The panel behind "Mai multe opțiuni" holds nothing but the recurring-event
    // section, so where recurring events are off the button opened an empty panel.
    hasMoreOptions() {
      return this.canScheduleRecurringEvents;
    },

    // This modal only ever creates an event with nobody attached -- scheduling a
    // student goes straight from the calendar to the server, never through here --
    // so the fields that live on the student's pivot (not attended, not paid,
    // skipped review) have nothing to apply to.
    visibleExtraFields() {
      return this.eventExtraFields.filter((field) => !field.requires_student);
    },

    selectedWeekDays() {
      return this.weekDays
        .filter((day) => day.selected)
        .map((day) => day.number);
    },
  },

  filters: {
    pad(num) {
      if (num < 10) return "0" + num;
      return num;
    },
  },

  watch: {},
};
</script>
<style>
</style>
